<div class="p-6 card-style-full">
  <div class="flex justify-between items-center mb-4">
    <h2 class="text-gray-700 font-bold">Documentos — {{ data.titulo }}</h2>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <supplier-portal-documents [escopo]="data.escopo" [ownerId]="data.ownerId" />
</div>
